"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const toolbar_button_1 = require("./toolbar_button");
const ui_react_1 = require("@streem/ui-react");
const GuideButton = ({ handleGuideToggle, showGuideUI, }) => {
    return ((0, jsx_runtime_1.jsx)(toolbar_button_1.ToolbarButton, { fill: ui_react_1.Theme.colors.azure, hoverFill: ui_react_1.Theme.colors.azureTransparent, label: `Tool Guide ${showGuideUI ? 'visible' : 'hidden'}. Click to ${showGuideUI ? 'hide' : 'show'}.`, iconName: showGuideUI ? 'InformationIcon' : 'InformationDisabledIcon', onClick: () => handleGuideToggle(), "data-testid": 'measurement-guide-button' }));
};
exports.GuideButton = GuideButton;
//# sourceMappingURL=guide_button.js.map